import './app.css';
import ConfigRouter from './components/ConfigRouter';
import Footer from './components/Footer';
import Header from './components/Header';
import GoToTop from './features/GoToTop';

function App() {
    return (
        <>
            <Header />

            <ConfigRouter />

            <GoToTop />
            <Footer />
        </>
    );
}

export default App;
